var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16 13.5H4V7.5H16V13.5ZM22 13.5V19.5H16V25.5H28V13.5H22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.5H4C3.73478 6.5 3.48043 6.60536 3.29289 6.79289C3.10536 6.98043 3 7.23478 3 7.5V25.5C3 25.7652 3.10536 26.0196 3.29289 26.2071C3.48043 26.3946 3.73478 26.5 4 26.5H28C28.2652 26.5 28.5196 26.3946 28.7071 26.2071C28.8946 26.0196 29 25.7652 29 25.5V7.5C29 7.23478 28.8946 6.98043 28.7071 6.79289C28.5196 6.60536 28.2652 6.5 28 6.5ZM11 18.5V14.5H21V18.5H11ZM5 18.5V14.5H9V18.5H5ZM23 14.5H27V18.5H23V14.5ZM27 12.5H17V8.5H27V12.5ZM15 8.5V12.5H5V8.5H15ZM5 20.5H15V24.5H5V20.5ZM17 24.5V20.5H27V24.5H17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall);
export default __webpack_public_path__ + "static/media/wall.80391152fe97da9612257b040d676c6a.svg";
export { ForwardRef as ReactComponent };